import { FormikProps } from 'formik';
import { Divider, Space } from 'antd';
import { UpOutlined, DownOutlined } from '@ant-design/icons';
import Button from 'components/new-ui/base/button/Button';
import DeclarationInput from 'components/ui/composed/declarations/formInput';
import DeclarationSelect from 'components/ui/composed/declarations/formSelect';
import { ICS2CodelistsMap } from 'store/codelists/code';
import { DeclarationTypes } from 'store/declarations/enums/common/declaration-types';
import { getFormikProps } from 'views/declarations/utils/form-utils';
import { H3 } from 'components/new-ui/base/typography/styles';
import LabelRequiredSymbol from 'components/new-ui/base/label/LabelRequiredSymbol';

type PlaceSectionProps = {
    formik: FormikProps<any>;
    expanded: boolean;
    onToggle: () => void;
    fieldPrefix: string;
    countryLabel: string;
    locationLabel: string;
    unLocodeRefNumber: string;
    countryRefNumber: string;
    locationRefNumber: string;
    title: string;
    required: boolean;
};

const PlaceSection = ({
    formik,
    expanded,
    onToggle,
    fieldPrefix,
    countryLabel,
    locationLabel,
    unLocodeRefNumber,
    countryRefNumber,
    locationRefNumber,
    title,
    required,
}: PlaceSectionProps) => {
    return (
        <div>
            <H3 style={{ marginBottom: 18 }}>
                {title} {required ? <LabelRequiredSymbol /> : null}
            </H3>
            <DeclarationSelect
                {...getFormikProps(`${fieldPrefix}.unlocode`, formik)}
                refNumber={unLocodeRefNumber}
                label="UN/LOCODE"
                condensed
                codeValidation={[]}
                codelistProps={{
                    codelistName: ICS2CodelistsMap.CL244,
                    declarationType: DeclarationTypes.ICS2,
                }}
            />

            <Divider>
                <Space size={8}>
                    <span>or</span>
                    <Button
                        style={{ color: 'var(--brand-6)', fontSize: 14 }}
                        icon={expanded ? <UpOutlined /> : <DownOutlined />}
                        onClick={onToggle}
                        type="link"
                    >
                        {expanded ? 'Enter UN/LOCODE' : 'Select Country & Location'}
                    </Button>
                </Space>
            </Divider>

            {expanded && (
                <>
                    <DeclarationSelect
                        {...getFormikProps(`${fieldPrefix}.address.country`, formik)}
                        refNumber={countryRefNumber}
                        label={countryLabel}
                        condensed
                        codeValidation={[]}
                        codelistProps={{
                            codelistName: ICS2CodelistsMap.CL718,
                            declarationType: DeclarationTypes.ICS2,
                        }}
                    />

                    <DeclarationInput
                        refNumber={locationRefNumber}
                        label={locationLabel}
                        {...getFormikProps(`${fieldPrefix}.location`, formik)}
                        condensed
                    />
                </>
            )}
        </div>
    );
};

export default PlaceSection;
